// @ts-check
import React from 'react';

import { useParams } from 'react-router-dom';

import AuthenticatedLayout from '../layouts/AuthenticatedLayout';
import BusinessViewFlowDetail from '@components/cards/businessview/detail/BusinessViewFlowDetail';

/**
 * Business View flow detail page. Wraps the flow detail component in the
 * authenticated app shell (navbar + sidebar + footer).
 *
 * Both ids come from the route: the DashboardAPI detail operation is addressed by
 * project and workflow, and the project cannot be inferred from the workflow.
 *
 * @returns {JSX.Element}
 */
export default function BusinessViewFlowDetailPage() {
  const { projectId, workflowId } = useParams();

  return (
    <AuthenticatedLayout>
      <BusinessViewFlowDetail projectId={projectId} workflowId={workflowId} />
    </AuthenticatedLayout>
  );
}